import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { GetAllEnrollments } from '../../store/enrollments/enrollments.actions';
import { combineLatest } from 'rxjs';
import { selectEnrollmentsHaveBeenLoaded } from '../../store/enrollments/enrollments.selectors';
import { filter, map, tap } from 'rxjs/operators';
import { selectComplianceFormHasBeenLoaded } from '../../store/compliance-form/compliance-form.selectors';
import { GetComplianceForm } from '../../store/compliance-form/compliance-form.actions';
import { ComplianceFormPermissions } from '../../../permissions/permissions';
import {
  IRouteData,
  PermissionsService,
} from '../../services/permissions/permissions.service';

export const requiredTasksGuard: CanActivateFn = (_route, _state) => {
  const store = inject(Store);
  const permissionsService = inject(PermissionsService);

  let dispatchedEnrollment = false;
  let dispatchedCompliance = false;

  return combineLatest({
    hasLoadedEnrollments: store.pipe(select(selectEnrollmentsHaveBeenLoaded)),
    hasLoadedComplianceForm: store.pipe(
      select(selectComplianceFormHasBeenLoaded),
    ),
    hasComplianceFormPermissions: permissionsService.hasRoutePermission(
      ComplianceFormPermissions as IRouteData,
    ),
  }).pipe(
    tap(
      ({
        hasLoadedEnrollments,
        hasLoadedComplianceForm,
        hasComplianceFormPermissions,
      }) => {
        if (!hasLoadedEnrollments && !dispatchedEnrollment) {
          dispatchedEnrollment = true;
          store.dispatch(GetAllEnrollments());
        }
        if (
          !hasLoadedComplianceForm &&
          !dispatchedCompliance &&
          hasComplianceFormPermissions
        ) {
          dispatchedCompliance = true;
          store.dispatch(GetComplianceForm());
        }
      },
    ),
    filter(
      ({
        hasLoadedEnrollments,
        hasLoadedComplianceForm,
        hasComplianceFormPermissions,
      }) =>
        (hasLoadedComplianceForm || !hasComplianceFormPermissions) &&
        hasLoadedEnrollments,
    ),
    map(
      ({
        hasLoadedEnrollments,
        hasLoadedComplianceForm,
        hasComplianceFormPermissions,
      }) =>
        (hasLoadedComplianceForm || !hasComplianceFormPermissions) &&
        hasLoadedEnrollments,
    ),
  );
};
